export const API_KEY = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJwbGF0Zm9ybSI6IkJBQ0tFTkQiLCJlbnZpcm9ubWVudCI6IkRFVkVMT1BNRU5UIiwiY3VycmVudCI6IjIwMjAtMDgtMDVUMjI6Mzg6MDkuOTg5WiJ9.k4XuXVP6Uf29wwLF2GwAUnlfCujfInCFW8gWZmfdOEA';
